import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import DataImport from "./DataImport";
import DataSettings from "./DataSettings";
import DataProperties from "./DataProperties";
import { Navigation } from "../Navigation";

const DataLayout = (props:any) => {
    let { path, url } = useRouteMatch();

    return (
        <div>
            <Navigation {...props}/>
            <div>
                <Switch>
                    <Route exact path={path}>
                        <Redirect to="/data/settings" push={true} />
                    </Route>
                    <Route path={`${path}/settings`}>
                        <DataSettings {...props}></DataSettings>
                    </Route>                            
                    <Route path={`${path}/properties`}>
                        <DataProperties {...props}></DataProperties>
                    </Route>
                    <Route path={`${path}/import`}>
                        <DataImport {...props}></DataImport>
                    </Route>
                </Switch>
            </div>
        </div>
    );
}

export default DataLayout;

